<template>
  <div class="userAgent-page">
    <h1 class="page-title">Users</h1>
    <b-col xs="12">
      <Widget
          title="<h5>Listed <span class='fw-semi-bold'>General Users</span></h5>"
          bodyClass="widget-table-overflow"
          customHeader>
        <p class="ml-4">This table shows the list of users</p>
        <div class="row">
          <div class="col-8 ml-4">
            <b-input type="text" v-model="search" placeholder="Search for users...."
                     title="Type in a name"/>
          </div>
          <b-button class="col-1 p-0 ml-0 fa fa-search" variant="light" size="sm" @click="searchUser">search
          </b-button>
          <b-button class="col-1 p-0 ml-1" variant="danger" size="sm" @click="loadUsers">clear
          </b-button>
        </div>
        <br>
        <div class="table-responsive">
          <table class="table table-lg mb-0 requests-table">
            <thead>
            <tr class="text-muted">
              <th>MOBILE</th>
              <th>BALANCE</th>
              <th>ACTIONS</th>
              <!--              <th>WORK STATUS</th>-->
            </tr>
            </thead>
            <tbody>
            <tr v-for="user in users" :key="user.id">
              <td>{{ user.mobile }}</td>
              <td>{{ user.balance }}</td>
              <td>
                <b-button @click="setUserForAgentModal(user)"
                          variant="success"
                          class="p-1 px-3 btn-xs">
                  make agent
                  <b-modal v-model="showAgentCreateModal" centered title="Ekhoni Daktar" @ok="convertUserToAgent">
                    <h4 v-if="selectUser" class="text-center">{{ selectUser.mobile }}</h4>
                    <!--            post_grad-->
                    <b-form-group id="amount_group" label="Agent Percentage * :" label-for="agent_percentage"
                                  description="Enter Agent Commission in %">
                      <b-form-input id="agent_percentage" v-model="agentCreateForm.agent_percentage" required
                                    type="number"
                                    placeholder="Amount percentage"></b-form-input>
                    </b-form-group>
                  </b-modal>

                </b-button>
                <b-button variant="outline-success" class="p-1 px-3 btn-xs ml-2">
                  <router-link :to="{name: 'userDetails', query: { id: user.id }}">Details</router-link>
                </b-button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </Widget>
    </b-col>
  </div>
</template>

<script>

import Widget from "../../../components/admin/Widget/Widget";
import UserService from "@/services/admin/user.service";
import {Form} from "vform";

export default {
  name: 'Users',
  components: {
    Widget,
  },
  data() {
    return {
      showAgentCreateModal: false,
      search: '',
      selectUser: null,
      users: [],
      agentCreateForm: new Form({
        'is_agent': 1,
        'agent_percentage': 0,
      })
    };
  },
  methods: {
    setUserForAgentModal(user) {
      this.showAgentCreateModal = true;
      this.selectUser = user;
    },
    searchUser(){
      UserService.searchUser(0, this.search)
      .then((response) => {
        if(response.status === 200){
          this.users = response.data;
        }
      })
    },
    loadUsers() {
      this.search = '';
      UserService.fetchUsers(0)
          .then((response) => {
            if (response.status === 200) {
              this.users = response.data.data;
            }
          })
    },
    convertUserToAgent() {
      UserService.convertAgentStatus(this.selectUser.id, this.agentCreateForm)
          .then((response) => {
            if (response.status === 204) {
              this.agentCreateForm.reset();
              this.loadUsers();
            }
          })
    }

  },
  mounted() {
    this.loadUsers();
  }

};
</script>

<style src="./Users.scss" lang="scss"/>
